export function easeInOut(t, amt=2) {
    let tPow = Math.pow(t, amt);
    return tPow / (tPow + Math.pow(1 - t, amt));
}

export function sinEaseInOut(t) {
	return 0.5 - 0.5 * Math.cos(Math.PI * t);
}

export function slurp(val1, val2, amt) {
    return (val2 - val1) * amt + val1;
}

export function experp(val1, val2, amt) {
    return Math.exp(
        slurp(
            Math.log(val1),
            Math.log(val2),
            amt
        )
    )
}

export function clampedSlurp(val1, val2, amt) {
    if (amt < 0) {
        return val1;
    }
    if (amt > 1) {
        return val2;
    }
    return slurp(val1, val2, amt);
}

export function clamp(amt, val1, val2) {
    if (amt < 0) {
        return val1;
    }
    if (amt > 1) {
        return val2;
    }
    return amt;
}

/**
 * Extracts a 0-1 interval from a section of a 0-1 interval
 *
 * For example, if min == 0.3 and max == 0.7, you get:
 *
 *           0.3  0.7
 *     t: 0 --+----+-- 1
 *           /      \
 *          /        \
 *         /          \
 *     -> 0 ---------- 1
 *
 * Useful for making sub animations.
 *
 * Doesn't do any clamping, so you might want to clamp yourself.
 */
export function divideInterval(t, min, max) {
    return (t - min) / (max - min);
}

export function rgb(r, g, b) {
    r = Math.round(r);
    g = Math.round(g);
    b = Math.round(b);
	return `rgb(${r},${g},${b})`;
}

export function hsl(h, s, l) {
    h = Math.round(h);
    s = Math.round(s);
    l = Math.round(l);
    return `hsl(${h},${s}%,${l}%)`;
}

export function hslLerp(color1, color2, amt) {
    return {
        h: 360 * angleLerp(color1.h / 360, color2.h / 360, amt),
        s: slurp(color1.s, color2.s, amt),
        l: slurp(color1.l, color2.l, amt),
    }
}

/**
 * @param {number} angle1 0 to 1
 * @param {number} angle2 0 to 1
 * @param {number} amt 0 to 1
 */
export function angleLerp(angle1, angle2, amt) {
    return radianAngleLerp(2 * Math.PI * angle1, 2 * Math.PI * angle2, amt) / (2 * Math.PI);
}

export function radianAngleLerp(angle1, angle2, amt) {
    const x1 = Math.cos(angle1);
    const y1 = Math.sin(angle1);
    const x2 = Math.cos(angle2);
    const y2 = Math.sin(angle2);
    const x3 = slurp(x1, x2, amt);
    const y3 = slurp(y1, y2, amt);
    return Math.atan2(y3, x3);
}

export function gray(whiteAmt) {
    whiteAmt = clamp(whiteAmt, 0, 1);
	const whiteRgb = Math.floor(255 * whiteAmt);
	return rgb(whiteRgb, whiteRgb, whiteRgb);
}


// WEBPACK FOOTER //
// ./src/js/util.js